/**
 * Receipt Download Button
 * Small button to download PDF receipt for a transaction
 * Supports multi-language receipts
 */
import { Button } from '../components/ui/button';
import { getReceiptUrl, getBatchReceiptUrl } from '../lib/api';
import { toast } from 'sonner';
import { FileText } from 'lucide-react';

const ReceiptButton = ({ transactionId, batchId, variant = 'ghost', size = 'sm', lang = 'en' }) => {
  const handleDownload = () => {
    try {
      const url = batchId ? getBatchReceiptUrl(batchId) : getReceiptUrl(transactionId, lang);
      window.open(url, '_blank');
      toast.success('Downloading receipt...');
    } catch (error) {
      toast.error('Failed to download receipt');
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleDownload}
      className="gap-1"
      title="Download Receipt"
      data-testid={`receipt-btn-${transactionId || batchId}`}
    >
      <FileText className="w-3 h-3" />
      <span className="sr-only">Download Receipt</span>
    </Button>
  );
};

export default ReceiptButton;
